export const COLOR_UNIT = 'COLR';
export const SIZE_UNIT = 'SIZE';
export const ANY_UNIT = 'ANY';

export const LabelByFilterValue = {
  [ANY_UNIT]: 'Any',
  [COLOR_UNIT]: 'Color',
  [SIZE_UNIT]: 'Size',
};

export const ACTIVE_STATE = 'active';
export const INACTIVE_STATE = 'inactive';
